export const callbackIterableArray = (array, callback) => array.forEach(callback);
